import { motion, useScroll, useTransform } from "motion/react";
import { useRef, memo } from "react";

function ListItem({ text, level, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.2, 0.8, 1],
    [0, 1, 1, 0.6]
  );
  const x = useTransform(scrollYProgress, [0, 0.2], [20, 0]);

  const getBulletStyle = () => {
    if (level === 0) {
      return "text-[#fd5b38]";
    } else if (level === 1) {
      return "text-[rgba(253,91,56,0.6)]";
    } else {
      return "text-[rgba(253,91,56,0.6)]";
    }
  };

  const getBullet = () => {
    if (level === 0) return "•";
    if (level === 1) return "◐";
    return "○";
  };

  const getMarginLeft = () => {
    if (level === 0) return "ml-0";
    if (level === 1) return "ml-4 sm:ml-6";
    return "ml-4 sm:ml-6";
  };

  return (
    <motion.div
      ref={ref}
      className={`flex gap-2 sm:gap-3 items-start ${getMarginLeft()}`}
      style={{ opacity, x }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.5,
        delay: index * 0.05,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      whileHover={{
        x: 5,
        transition: { duration: 0.2, ease: "easeOut" },
      }}
      role="listitem"
      aria-level={level + 1}
    >
      <span
        className={`${getBulletStyle()} shrink-0 select-none`}
        aria-hidden="true"
      >
        {getBullet()}
      </span>
      <p className="text-[#d1d5dc] leading-relaxed text-sm sm:text-base">
        {text}
      </p>
    </motion.div>
  );
}

export const ListItemComponent = memo(ListItem);
